import { render } from "./list-share-users.vue?vue&type=template&id=3cc9d5a0&scoped=true&ts=true"
import script from "./list-share-users.vue?vue&type=script&lang=ts"
export * from "./list-share-users.vue?vue&type=script&lang=ts"

import "./list-share-users.vue?vue&type=style&index=0&id=3cc9d5a0&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cc9d5a0"]])

export default __exports__